module.exports = __webpack_public_path__ + "static/EuclidTriangle-Semibold-WebS-116b1897c69be8b1b8bbef8eaa87ad30.woff";